import React, { useState } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"

import avatar1 from "../../assets/images/users/profile.png"
import AdminProfile from "pages/Authentication/AdminProfile"
import secureLocalStorage from "react-secure-storage"

const WelcomeComp = () => {
  const [profileModal, setProfileModal] = useState(false);

  const { name, email, photoPhoto } = secureLocalStorage.getItem("authUser")

  const profileImage = photoPhoto ? `${process.env.REACT_APP_IMAGE_PATH}/${photoPhoto}` : avatar1

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className=" profile_nav">
          <Row>
            <Col xs="12">
              <div className="text-white p-3">
                <h5 className="text-white">Welcome Back !</h5>
                <p>Peacock Accountants Limited </p>
              </div>
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            
            <Col sm="12">
              <div className="avatar-md profile-user-wid mb-2">
                <img
                  src={profileImage}
                  alt=""
                  style={{ height: 70, width: 70, objectFit: 'cover', objectPosition: 'top' }}
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <div className="d-flex justify-content-between align-items-end mb-1">
                <h5 className="font-size-15 text-truncate mb-1">{name?.split(' ')[0] || 'Your Name'}</h5>
                <div >
                  <button
                    onClick={() => setProfileModal(true)}
                    className="btn btn-primary  btn-sm"
                  >
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </button>
                </div>
              </div>
              <p className="text-muted mb-0 text-truncate" title={email}>{email}</p>
            </Col>

            {/* <Col sm="6">
              <div className="pt-4">
                <div className="mt-4">
                  <button
                    onClick={() => setProfileModal(true)}
                    className="btn btn-primary  btn-sm"
                  >
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </button>
                </div>
              </div>
            </Col> */}

          </Row>
        </CardBody>
      </Card>

      <AdminProfile modal={profileModal} setModal={setProfileModal} />

    </React.Fragment>
  )
}
export default WelcomeComp
